import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

function formatAgeHours(h) {
  if (h == null) return '—';
  if (h < 1) return '< 1 h';
  return `${h} h`;
}

/**
 * Alertes sessions / tables anormalement anciennes ou obligations restaurant.
 */
export default function PosOperationalAlertsBanner({ health, commercantId, onDismiss, dismissed }) {
  if (!health?.hasAlerts || dismissed) return null;

  const staleTables = health.staleRestaurantSessions || [];
  const financial = health.restaurantFinancialBlockers || [];
  const staleCaisse = health.staleCaisseSessions || [];

  return (
    <div
      data-testid="pos-operational-alerts"
      className="mb-4 rounded-2xl border-2 border-amber-400 bg-amber-50 px-4 py-3 text-amber-950 shadow-sm"
      role="alert"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-6 w-6 shrink-0 mt-0.5" aria-hidden />
        <div className="flex-1 min-w-0 space-y-2 text-sm">
          <p className="font-bold text-base">Contrôles caisse / restaurant</p>
          {staleTables.length > 0 && (
            <div>
              <p className="font-semibold">
                {staleTables.length} table(s) ouverte(s) depuis plus de{' '}
                {health.staleThresholdHours} h
              </p>
              <ul className="mt-1 space-y-1 list-disc pl-4">
                {staleTables.slice(0, 6).map((s) => (
                  <li key={s.sessionId}>
                    Table {s.tableLabel || s.tableId?.slice(-6)} — ouverte{' '}
                    {formatAgeHours(s.ageHours)}
                    {s.hasFinancialBlockers ? ' · addition non soldée' : ''}
                    {' · '}
                    <Link
                      to={s.deepLinkPath || `/caisse/restaurant?commercantId=${commercantId}`}
                      className="font-semibold underline"
                    >
                      Ouvrir le plan
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {financial.length > 0 && (
            <p className="font-semibold text-red-800">
              {financial.length} service(s) restaurant avec solde dû — clôture caisse bloquée
              tant que non soldé ou table libérée.
            </p>
          )}
          {staleCaisse.length > 0 && (
            <p>
              Session de caisse ouverte depuis{' '}
              {formatAgeHours(staleCaisse[0]?.ageHours)} sur{' '}
              {staleCaisse[0]?.posteLabel || 'poste'} — vérifiez clôture ou reprise.
            </p>
          )}
          {health.multiCaisseSessionsOpen && (
            <p>Plusieurs sessions de caisse ouvertes sur ce commerce.</p>
          )}
        </div>
        {onDismiss && (
          <button
            type="button"
            className="shrink-0 min-h-[44px] px-3 rounded-xl border border-amber-500 text-sm font-semibold"
            onClick={onDismiss}
          >
            Masquer
          </button>
        )}
      </div>
    </div>
  );
}
